import type { FC, ReactNode } from 'react'
import type { LegalSection } from '@/components/generals/legal-page'

import { LegalPage } from '@/components/generals/legal-page'

import { studio } from '@/constants/site'

const sections: readonly LegalSection[] = [
    {
        heading: 'Using this site',
        paragraphs: [
            `This site is published by ${studio.brand}, the studio of ${studio.artist}. By browsing it you accept the terms below.`,
            'You are welcome to read, link to, and share anything here. That is what it is for.'
        ]
    },
    {
        heading: 'The work itself',
        paragraphs: [
            'Every image, film, text and design on this site is owned by the studio or used with permission. Copyright stays where it is.',
            'You may not reproduce, resell, train models on, or pass off any of this work as your own. Reposting a single image with clear credit and a link back is fine; wholesale copying is not.'
        ]
    },
    {
        heading: 'Commissions and enquiries',
        paragraphs: [
            'Nothing on this site is an offer of contract. Project scope, fees, licensing and delivery are agreed in writing before any work starts.',
            'Sending a message through the contact form starts a conversation, nothing more.'
        ]
    },
    {
        heading: 'Accuracy',
        paragraphs: [
            'Dates, clients and descriptions are recorded as accurately as possible, but this is a working archive and some entries change as projects do.',
            'Nothing here is professional advice and no guarantee is made that the site will be available without interruption.'
        ]
    },
    {
        heading: 'Liability',
        paragraphs: [
            'The studio is not liable for loss arising from use of this site or from reliance on anything published on it, to the extent the law allows.',
            'Nothing in these terms limits liability for anything that cannot legally be limited.'
        ]
    },
    {
        heading: 'Changes and governing law',
        paragraphs: [
            'These terms can change. The current version is always the one on this page, with its date at the top.',
            'They are governed by the laws of England and Wales.'
        ]
    }
]

const TermsOfUsePage: FC = (): ReactNode => (
    <LegalPage
        title='Terms of use'
        updated='1 January 2026'
        intro='The rules for using this site and the work published on it. Short, and meant to be read.'
        sections={sections}
    />
)

export default TermsOfUsePage
